export function TERMOFSERVICE_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function TERMOFSERVICE_SUCCESS(state, payload) {
  state;
  state.termofservices = payload.results.data;
  state.totalPage = payload.results.totalPage;
  state.isLoading = false;
}
export function TERMOFSERVICE_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function GET_TERMOFSERVICE_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function GET_TERMOFSERVICE_SUCCESS(state, payload) {
  state;
  state.termofservice = payload.results.data;
  state.isLoading = false;
}
export function GET_TERMOFSERVICE_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function CREATE_TERMOFSERVICE_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function CREATE_TERMOFSERVICE_SUCCESS(state, payload) {
  state;
  state.termofservices = [...state.termofservices, payload.results.data];
  state.isLoading = false;
}
export function CREATE_TERMOFSERVICE_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function EDIT_TERMOFSERVICE_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function EDIT_TERMOFSERVICE_SUCCESS(state, payload) {
  state;
  state.termofservices = state.termofservices.map(item => {
    if (item.id === payload.results.data.id) {
      return Object.assign({}, item, payload.results.data);
    }
    return item;
  });
  state.isLoading = false;
}
export function EDIT_TERMOFSERVICE_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function DELETE_TERMOFSERVICE_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function DELETE_TERMOFSERVICE_SUCCESS(state, payload) {
  let index = state.termofservices.findIndex(item => item.id == payload.id);
  state.termofservices.splice(index, 1);
  state;
  state.termofservices;
  state.isLoading = false;
}
export function DELETE_TERMOFSERVICE_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
